import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subscription, debounceTime, interval, map, startWith } from 'rxjs';
import { companiaLista } from 'src/app/interface/CompaniaListaInterface';
import { SseService } from 'src/app/services/SseService';
import { TemaService } from 'src/app/services/tema.services';
import { WatchlistService } from 'src/app/services/watchlist.services';
import { slugMercado } from 'src/app/utils/mercado-url.util';
import { HelpDialogComponent, HelpDialogData } from '../common/help-dialog/help-dialog.component';

@Component({
  selector: 'app-analisis-data',
  templateUrl: './analisis-data.component.html',
  styleUrl: './analisis-data.component.scss'
})
export class AnalisisDataComponent implements OnDestroy {
  private readonly DEFAULT_WATCHLIST_SYMBOLS = ['AAPL', 'MSFT', 'TSLA', 'GOOGL', 'AMZN'];
  private readonly WATCHLIST_AVATAR_COLORS = ['wl-color-0', 'wl-color-1', 'wl-color-2', 'wl-color-3', 'wl-color-4'];
  public isAnalisis: boolean=true;
  public companias: any;
  myControl = new FormControl('');
  options: any;
  filteredOptions: Observable<any[]>;
  public selectedIso: any;
  public companiaselected: any;
  /** true si el mercado de la compañía mostrada es MetaAPI (la gráfica pide metahistoricos). */
  public selectedMetaapi: boolean = false;
  /** idNectum de la compañía mostrada, necesario para descargar sus datos; null si no se conoce. */
  public selectedIdNectum: number | null = null;
  public selectedTab:number=0;
  public data1: any;
  public token: any;
  public mercado: any;
  public   selectedValue: string;
  public keymetricsttm:any;
  public ratiosttm: any;
  public quoteshort: any;
  public invertirEstilos: boolean=true;
  public SubTema: Subscription;
  public watchlist: any[] = [];
  public watchlistQuotes: { [iso: string]: any } = {};
  public watchlistGroups: { group: string, items: any[] }[] = [];
  public collapsedGroups: Set<string> = new Set<string>();
  public watchlistPollSub: Subscription;
  /** Login de la cuenta MetaTrader conectada (lo guarda el login de broker); '' si no hay. */
  public metaapiCuenta: string = localStorage.getItem('meta_api_account_login') || '';
  private storageListener = (e: StorageEvent) => {
    if (e.key === 'meta_api_account_login') {
      this.metaapiCuenta = e.newValue || '';
    }
  };
  watchlistControl = new FormControl('');
  watchlistFilteredOptions: Observable<any[]>;
  /** Segmentos :mercado ("<idmercado>-<slug>") y :activo de la URL; null si no vienen. */
  private mercadoUrl: string | null = null;
  private activoUrl: string | null = null;
  private paramsSub: Subscription;
  /** true mientras el mercado de la URL no se ha resuelto: aún no se sabe si el activo es MetaAPI. */
  public mercadoPendiente: boolean = false;


  constructor(private _sseservice: SseService, private _cookieService: CookieService, private _httclient: HttpClient, public temaservicio: TemaService, private dialog: MatDialog, private _watchlistService: WatchlistService, private route: ActivatedRoute, private router: Router){

  }


  ngOnInit() {
    this.selectedIso = this.route.snapshot.paramMap.get('activo') || 'AAPL';
    this.mercadoPendiente = !!this.route.snapshot.paramMap.get('mercado');
    this.cargarData(this.selectedIso);
    this.token=this._cookieService.get('auth_token');
    this.paramsSub = this.route.paramMap.subscribe(params => {
      this.mercadoUrl = params.get('mercado');
      this.activoUrl = params.get('activo');
      this.aplicarUrl();
    });
    this._sseservice.apiPostNew("listamercados", {}, this.token).subscribe({
      next: (data:any)=>{
        console.log(data);
        this.mercado=data;
        this.aplicarUrl();
      }
    });
    this.SubTema = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any)=>{
          this.invertirEstilos = data;
      }
  });
    window.addEventListener('storage', this.storageListener);
    this.loadWatchlist();
    this.watchlistPollSub = interval(20000).subscribe(()=>{
      this.refreshWatchlistQuotes();
    });

  }

  loadWatchlist(){
    this._watchlistService.getWatchlist(this.token).subscribe({
      next: (data: any)=>{
        this.watchlist = data || [];
        if(this.watchlist.length === 0){
          this.DEFAULT_WATCHLIST_SYMBOLS.forEach(iso => this.addToWatchlist(iso));
        } else {
          this.refreshWatchlistQuotes();
        }
      }
    });
  }

  refreshWatchlistQuotes(){
    this.watchlist.forEach((item: any)=>{
      this._sseservice.apiGetNew('v3/quote/' + item.simbolo).subscribe({
        next: (data: any)=>{
          this.watchlistQuotes[item.simbolo] = data && data.length > 0 ? data[0] : null;
          this.recomputeWatchlistGroups();
        }
      });
    });
  }

  addToWatchlist(iso: string){
    if(!iso){ return; }
    this._watchlistService.addSymbol(iso, this.token).subscribe({
      next: (item: any)=>{
        if(!this.watchlist.find((w: any) => w.simbolo === item.simbolo)){
          this.watchlist.push(item);
        }
        this._sseservice.apiGetNew('v3/quote/' + item.simbolo).subscribe({
          next: (data: any)=>{
            this.watchlistQuotes[item.simbolo] = data && data.length > 0 ? data[0] : null;
            this.recomputeWatchlistGroups();
          }
        });
        this.watchlistControl.setValue('');
      }
    });
  }

  removeFromWatchlist(simbolo: string, event: Event){
    event.stopPropagation();
    this._watchlistService.removeSymbol(simbolo, this.token).subscribe({
      next: ()=>{
        this.watchlist = this.watchlist.filter((w: any) => w.simbolo !== simbolo);
        delete this.watchlistQuotes[simbolo];
        this.recomputeWatchlistGroups();
      }
    });
  }

  recomputeWatchlistGroups(){
    const groupsMap = new Map<string, any[]>();
    this.watchlist.forEach((item: any)=>{
      const group = this.watchlistQuotes[item.simbolo]?.exchange || 'Otros';
      if(!groupsMap.has(group)){
        groupsMap.set(group, []);
      }
      groupsMap.get(group)!.push(item);
    });
    this.watchlistGroups = Array.from(groupsMap.entries()).map(([group, items]) => ({ group, items }));
  }

  toggleGroup(group: string){
    if(this.collapsedGroups.has(group)){
      this.collapsedGroups.delete(group);
    } else {
      this.collapsedGroups.add(group);
    }
  }

  avatarColor(simbolo: string): string {
    let hash = 0;
    for(let i = 0; i < simbolo.length; i++){
      hash = simbolo.charCodeAt(i) + hash;
    }
    return this.WATCHLIST_AVATAR_COLORS[Math.abs(hash) % this.WATCHLIST_AVATAR_COLORS.length];
  }

  selectFromWatchlist(iso: string){
    this.selectedIso = iso;
    this.sincronizarCompania();
    this.cargarData(iso);
    this.actualizarUrl();
  }

  /** Datos de la compañía mostrada, si pertenece al mercado seleccionado. */
  private sincronizarCompania(){
    this.companiaselected = Array.isArray(this.companias) ? this.companias.find((compania: any) => compania.iso === this.selectedIso) : undefined;
    // La watchlist y la URL no fijan el mercado del activo: sólo se sabe si pertenece al mercado seleccionado.
    this.selectedMetaapi = this.companiaselected ? this.mercadoEsMetaapi() : false;
    this.selectedIdNectum = this.companiaselected?.idNectum ?? null;
    // El combo Compañía muestra el activo aunque no se haya elegido en él (URL o watchlist).
    this.myControl.setValue(this.companiaselected ? this.selectedIso : '', { emitEvent: false });
  }

  /** Lleva a la pantalla el mercado y el activo de la URL (/mercados/<id>-<slug>/<activo>). */
  private aplicarUrl(){
    if(this.activoUrl && this.activoUrl !== this.selectedIso){
      this.selectedIso = this.activoUrl;
      this.sincronizarCompania();
      this.cargarData(this.activoUrl);
    }
    if(!this.mercadoUrl || !Array.isArray(this.mercado)){ return; }
    // Sólo cuenta el id del principio; el slug es decorativo y se corrige si no coincide.
    const id = parseInt(this.mercadoUrl, 10);
    const mercado = this.mercado.find((m: any) => m.idmercado == id);
    if(!mercado){
      // Mercado inexistente o sin acceso para este usuario.
      this.liberarMercadoPendiente();
      this.router.navigate(['/mercados'], { replaceUrl: true });
      return;
    }
    if(mercado.idmercado !== this.selectedValue){
      this.selectedValue = mercado.idmercado;
      this.buscarCompania();
    } else {
      this.actualizarUrl();
    }
  }

  /** Refleja en la URL el mercado y el activo mostrados. Sin mercado seleccionado se queda en /mercados. */
  private actualizarUrl(){
    const mercado = Array.isArray(this.mercado) ? this.mercado.find((m: any) => m.idmercado == this.selectedValue) : null;
    if(!mercado){ return; }
    const ruta = ['/mercados', slugMercado(mercado)];
    if(this.selectedIso){ ruta.push(this.selectedIso); }
    this.router.navigate(ruta, { replaceUrl: true });
  }

  get mercadoSeleccionadoEsMetaapi(): boolean {
    return this.mercadoEsMetaapi();
  }

  private mercadoEsMetaapi(): boolean {
    return this.mercado?.find((m: any) => m.idmercado == this.selectedValue)?.metaapi === true;
  }

  private _filterWatchlist(value: string): any[] {
    if(!this.options){ return []; }
    const filterValue = (value || '').toLowerCase();
    return this.options.filter((option: companiaLista) =>
      option.iso.toLowerCase().includes(filterValue) || option.descripcion.toLowerCase().includes(filterValue)
    );
  }

  buscarCompania(){
    const jsonData = {
      idmercado: this.selectedValue
    };
    this._sseservice.apiPostNew('listadecompaniaspormercado',jsonData, this.token).subscribe({
      next: (data: any)=>{
        this.companias = data;
        console.log("data: ", data);
/*         this.options = data.map((compania: any) => {
          return {
            descripcion: compania.descripcion,
            iso: compania.iso
          };
        }); */
        this.options=data;
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          debounceTime(200),
          map(value => this._filter(value || '')),
        );
        this.watchlistFilteredOptions = this.watchlistControl.valueChanges.pipe(
          startWith(''),
          debounceTime(200),
          map(value => this._filterWatchlist(value || '')),
        );
        this.sincronizarCompania();
        // Ya se sabe si el activo es MetaAPI en este mercado: carga (o descarta) los datos de FMP.
        this.mercadoPendiente = false;
        this.cargarData(this.selectedIso);
        this.actualizarUrl();
      },
      error: () => this.liberarMercadoPendiente()
    });
  }

  /** Deja de esperar al mercado de la URL y carga lo que estaba en espera. */
  private liberarMercadoPendiente(){
    if(!this.mercadoPendiente){ return; }
    this.mercadoPendiente = false;
    this.cargarData(this.selectedIso);
  }

/*   private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.options.filter((option: companiaLista) => 
      option.descripcion.toLowerCase().includes(filterValue) || option.iso.toLowerCase().includes(filterValue)
    );
  } */

    private _filter(value: string): any[] {
      console.log("Estos entra en VALUE: ", this.options);
      const filterValue = value.toLowerCase();
      const criteria = filterValue.split(' ');
    
      // Inicializar filtros para iso y descripcion
      let isoFilter = '';
      let descripcionFilter = '';
      let mercadoFilter = '';
      let tipoFilter = '';
      let volumenFilter: { operator: string, value: number } | null = null;
      let cotizacionFilter: { operator: string, value: number } | null = null;

      // Iterar sobre los criterios y asignar filtros
      criteria.forEach(criterion => {
        if (criterion.startsWith('iso:')) {
          isoFilter = criterion.replace('iso:', '');
        } else if (criterion.startsWith('descripcion:')) {
          descripcionFilter = criterion.replace('descripcion:', '');
        }else if (criterion.startsWith('mercado:')) {
          mercadoFilter = criterion.replace('mercado:', '');
        }else if (criterion.startsWith('tipo:')) {
          tipoFilter = criterion.replace('tipo:', '');
        }else if (criterion.startsWith('volumen>')) {
          const value = parseFloat(criterion.substring(8).trim());
          if (!isNaN(value)) {
            volumenFilter = { operator: '>', value: value };
          }
        } else if (criterion.startsWith('volumen<')) {
          const value = parseFloat(criterion.substring(8).trim());
          if (!isNaN(value)) {
            volumenFilter = { operator: '<', value: value };
          }
        }else if (criterion.startsWith('cotizacion>')) {
          const value = parseFloat(criterion.substring(11).trim());
          if (!isNaN(value)) {
            cotizacionFilter = { operator: '>', value: value };
          }
        } else if (criterion.startsWith('cotizacion<')) {
          const value = parseFloat(criterion.substring(11).trim());
          if (!isNaN(value)) {
            cotizacionFilter = { operator: '<', value: value };
          }
        }
      });
    
      return this.options.filter((option: companiaLista) => {
        const matchesIso = isoFilter ? option.iso.toLowerCase().includes(isoFilter) : true;
        const matchesDescripcion = descripcionFilter ? option.descripcion.toLowerCase().includes(descripcionFilter) : true;
        const mercadoMatch = mercadoFilter === '' || (option.mercado && option.mercado.toLowerCase().includes(mercadoFilter));
        const tipoMatch = tipoFilter === '' || (option.tipo && option.tipo.toLowerCase().includes(tipoFilter));
        let volumenMatch = true;
        if (volumenFilter) {
          switch (volumenFilter.operator) {
            case '>':
              volumenMatch = option.volumen > volumenFilter.value;
              break;
            case '<':
              volumenMatch = option.volumen < volumenFilter.value;
              break;
          }
        }
        let cotizacionMatch = true;
        if (cotizacionFilter) {
          switch (cotizacionFilter.operator) {
            case '>':
              cotizacionMatch = option.precioteorico > cotizacionFilter.value;
              break;
            case '<':
              cotizacionMatch = option.precioteorico < cotizacionFilter.value;
              break;
          }
        }

        return matchesIso && matchesDescripcion && mercadoMatch && tipoMatch && volumenMatch && cotizacionMatch;
      });
    }
    
  
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    console.log(filterValue);

    // Dividir el valor del filtro en criterios separados
    const filters = filterValue.split(' ');

    // Definir los criterios de filtro
    let isoFilter = '';
    let mercadoFilter = '';
    let tipoFilter = '';
    let descripcionFilter = '';
    let companiaFilter = '';
    let volumenFilter: { operator: string, value: number } | null = null;
    let cotizacionFilter: { operator: string, value: number } | null = null;

    filters.forEach(filter => {
      if (filter.startsWith('iso:')) {
        isoFilter = filter.substring(4).trim();
      } else if (filter.startsWith('mercado:')) {
        mercadoFilter = filter.substring(8).trim();
      } else if (filter.startsWith('tipo:')) {
        tipoFilter = filter.substring(5).trim();
      } else if (filter.startsWith('descripcion:')) {
        descripcionFilter = filter.substring(12).trim();
      } else if (filter.startsWith('compañia:')) {
        companiaFilter = filter.substring(9).trim();
      } else if (filter.startsWith('volumen>')) {
        const value = parseFloat(filter.substring(8).trim());
        if (!isNaN(value)) {
          volumenFilter = { operator: '>', value: value };
        }
      } else if (filter.startsWith('volumen<')) {
        const value = parseFloat(filter.substring(8).trim());
        if (!isNaN(value)) {
          volumenFilter = { operator: '<', value: value };
        }
      }else if (filter.startsWith('cotizacion>')) {
        const value = parseFloat(filter.substring(11).trim());
        if (!isNaN(value)) {
          cotizacionFilter = { operator: '>', value: value };
        }
      } else if (filter.startsWith('cotizacion<')) {
        const value = parseFloat(filter.substring(11).trim());
        if (!isNaN(value)) {
          cotizacionFilter = { operator: '<', value: value };
        }
      }
    });
    console.log("esto es iso:", isoFilter);
    console.log("esto es mercadoFilter:", mercadoFilter);
    console.log("esto es tipoFilter:", tipoFilter);
    console.log("esto es volumenFilter:", volumenFilter);
    console.log("esto es cotizacionFilter:", cotizacionFilter);
    
    return this.options.filter(
      (item: companiaLista) => {
        const mercadoMatch = mercadoFilter === '' || (item.mercado && item.mercado.toLowerCase().includes(mercadoFilter));
        const tipoMatch = tipoFilter === '' || (item.tipo && item.tipo.toLowerCase().includes(tipoFilter))
        const descripcionMatch = descripcionFilter === '' || (item.descripcion && item.descripcion.toLowerCase().includes(descripcionFilter))
        const isoMatch = companiaFilter === '' || (item.iso && item.iso.toLowerCase().includes(companiaFilter))
        let volumenMatch = true;
        if (volumenFilter) {
          switch (volumenFilter.operator) {
            case '>':
              volumenMatch = item.volumen > volumenFilter.value;
              break;
            case '<':
              volumenMatch = item.volumen < volumenFilter.value;
              break;
          }
        }
        let cotizacionMatch = true;
        if (cotizacionFilter) {
          switch (cotizacionFilter.operator) {
            case '>':
              cotizacionMatch = item.precioteorico > cotizacionFilter.value;
              break;
            case '<':
              cotizacionMatch = item.precioteorico < cotizacionFilter.value;
              break;
          }
        }
        return mercadoMatch && tipoMatch && descripcionMatch && isoMatch && volumenMatch && cotizacionMatch;
        // return mercadoMatch;
      }
    );

  }
  
  selected(event: MatAutocompleteSelectedEvent){
    this.selectedMetaapi = this.mercadoEsMetaapi();
    this.selectedIso = event.option.value;
    this.companiaselected = this.companias.find((compania: any) => compania.iso === this.selectedIso);
    this.selectedIdNectum = this.companiaselected?.idNectum ?? null;
    console.log("compañia seleccionada o descripcion: ",this.companiaselected);
    console.log("cambio el select: ", this.selectedIso);
    this.cargarData(this.selectedIso);
    this.actualizarUrl();
  }

  cargarData(compania: any){
    // Los v3 son de FMP: no aplican a activos MetaAPI, y con el mercado de la URL sin resolver
    // aún no se sabe si lo es.
    if(this.selectedMetaapi || this.mercadoPendiente){
      this.keymetricsttm = this.ratiosttm = this.quoteshort = null;
      return;
    }
    let url='v3/key-metrics-ttm/'+compania;
    let url2='v3/ratios-ttm/'+compania;
    let url3='v3/quote-short/'+compania;
    if(this.selectedIso){
      this._sseservice.apiGetNew(url).subscribe({
        next: (data: any)=>{
          this.keymetricsttm = data;
        }
      });
      this._sseservice.apiGetNew(url2).subscribe({
        next: (data: any)=>{
          this.ratiosttm = data;
        }
      });
      this._sseservice.apiGetNew(url3).subscribe({
        next: (data: any)=>{
          this.quoteshort = data;
        }
      });
    }
  }

  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTab = event.index;
  }

  showTabHelp(tabName: string, event: Event): void {
    event.stopPropagation();
    let helpData: HelpDialogData;

    switch (tabName) {
      case 'Descripcion General':
        helpData = {
          title: 'Descripción General',
          items: [
            { term: 'Perfil de la Compañía', description: 'Información general sobre la empresa, sector y actividad principal.' },
            { term: 'Métricas Clave', description: 'Indicadores fundamentales como capitalización, P/E, dividendos, etc.' },
            { term: 'Resumen Ejecutivo', description: 'Visión general del estado actual de la compañía.' }
          ]
        };
        break;
      case 'Noticias':
        helpData = {
          title: 'Noticias',
          items: [
            { term: 'Noticias Recientes', description: 'Actualizaciones y noticias más recientes sobre la compañía.' },
            { term: 'Impacto de Mercado', description: 'Análisis del impacto de las noticias en el precio de las acciones.' }
          ]
        };
        break;
      case 'Estados Financieros':
        helpData = {
          title: 'Estados Financieros',
          items: [
            { term: 'Balance General', description: 'Activos, pasivos y patrimonio de la empresa.' },
            { term: 'Estado de Resultados', description: 'Ingresos, gastos y utilidades del período.' },
            { term: 'Flujo de Efectivo', description: 'Movimientos de efectivo operativo, de inversión y financiamiento.' }
          ]
        };
        break;
      case 'Datos Historicos':
        helpData = {
          title: 'Datos Históricos',
          items: [
            { term: 'Precios Históricos', description: 'Historial de precios de apertura, cierre, máximo y mínimo.' },
            { term: 'Volúmenes', description: 'Volúmenes de negociación históricos.' },
            { term: 'Tendencias', description: 'Patrones y tendencias identificadas en el historial.' }
          ]
        };
        break;
      case 'Presentaciones':
        helpData = {
          title: 'Presentaciones',
          items: [
            { term: 'Reportes a Inversionistas', description: 'Presentaciones oficiales para accionistas e inversionistas.' },
            { term: 'Conferencias', description: 'Transcripciones y materiales de conference calls.' },
            { term: 'Documentos SEC', description: 'Filings y documentos regulatorios.' }
          ]
        };
        break;
      default:
        helpData = {
          title: tabName,
          items: [{ term: 'Información', description: 'Información sobre esta sección.' }]
        };
    }

    this.dialog.open(HelpDialogComponent, {
      width: '450px',
      data: helpData
    });
  }

  ngOnDestroy(): void {
    this.SubTema.unsubscribe();
    this.paramsSub?.unsubscribe();
    window.removeEventListener('storage', this.storageListener);
    if(this.watchlistPollSub){
      this.watchlistPollSub.unsubscribe();
    }
  }
  formatLargeNumber(num: number): string {
    if (num === null) return '-';
    
    if (Math.abs(num) >= 1e12) {
      return (num / 1e12).toFixed(2) + 'T';
    } else if (Math.abs(num) >= 1e9) {
      return (num / 1e9).toFixed(2) + 'B';
    } else if (Math.abs(num) >= 1e6) {
      return (num / 1e6).toFixed(2) + 'M';
    } else if (Math.abs(num) >= 1e3) {
      return (num / 1e3).toFixed(2) + 'K';
    }
    return num.toFixed(2);
  }  
}
